<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-02-07 22:07:56
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-03-12 21:02:48
-->
<template>
  <el-dialog
    :visible.sync="isDialogShow"
    destroy-on-close
    width="800px"
    :before-close="onClose"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="dialog-title" slot="title">个人中心</div>
    <el-tabs tab-position="left">
      <el-tab-pane label="基本信息">
        <basic-info></basic-info>
      </el-tab-pane>
      <el-tab-pane label="密码修改">
        <password></password>
      </el-tab-pane>
      <el-tab-pane label="邮箱修改">
        <email></email>
      </el-tab-pane>
      <el-tab-pane label="手机号码修改">
        <phone></phone>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import BasicInfo from "./BasicInfo.vue";
import Password from "./Password.vue";
import Phone from "./Phone.vue";
import Email from "./Email.vue";
export default {
  name: "Personal",
  components: {
    BasicInfo,
    Password,
    Phone,
    Email,
  },
  props: {
    isDialogShow: {
      type: Boolean,
    },
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog__header {
    padding: 0;
    height: 40px;
    line-height: 40px;
  }
  .el-dialog__headerbtn {
    top: 12px;
  }
  .el-dialog__body {
    height: 400px;
  }
}
.dialog {
  &-title {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #777;
  }
}
</style>
